<template>
  <router-view />
</template>

<script>
export default {
  watch: {
    '$route':{
      immediate: true,
      handler: (to, from) => {
        document.title = to.meta.title || 'Enjoy Live Webcam with Ukrainian and Russian Girls'
      },
    }
  },
}
</script>
